import React from 'react';

// Material UI
import {Grid} from "@mui/material";

// Components
import MobileItem from "components/WMS/Mobile/MobileItem";
import LineItemOptionList from "components/WMS/Mobile/WmsItemList/components/LineItemOptionList";
import WmsItemCodes from "components/WMS/Mobile/WmsItemList/components/WmsItemCodes";
import WmsItemPlaceList from "components/WMS/Mobile/WmsItemList/components/WmsItemPlaceList";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import VariationCount from "components/WMS/Mobile/WmsItemList/components/VariationCount";

// Contexts
import {WMSContext} from "views/wms/context/WMSContext";

// Utils
import {WmsItemsStatus} from "utils/WmsItemsStatus";

function PickingOrInTrolleyItemList({retailerItems, wmsItems, onItemClick = (wmsItem) => {}}) {
    const { groupWmsItemsBySku } = React.useContext(WMSContext);

    function getInTrolleyTotalBySku(sku) {
        return retailerItems.filter(item => item.lineItem.variationSku === sku && item.status === WmsItemsStatus.IN_TROLLEY).length;
    }

    function getTotalProductBySku(sku) {
        return retailerItems.filter(item => item.lineItem.variationSku === sku).length;
    }

    return groupWmsItemsBySku(wmsItems).map((item, index) => {
        const totalBySku = getTotalProductBySku(item.lineItem.variationSku);
        const inTrolleyTotalBySku = getInTrolleyTotalBySku(item.lineItem.variationSku);

        return (
            <MobileItem onClick={() => onItemClick(item)} key={index}>
                <MobileItem.LeftSide
                    title={item.lineItem.name}
                    subtitle={<LineItemOptionList options={item.lineItem?.options} />}
                    underTitle={
                        <Grid container>
                            <WmsItemCodes wmsItem={item} />
                            <WmsItemPlaceList wmsItem={item} />
                        </Grid>
                    }
                >
                    <ThumbnailAndNotification
                        link={item.lineItem.pictures?.[0]}
                        alt={item.lineItem.name}
                        validated={inTrolleyTotalBySku > 0 && (inTrolleyTotalBySku === totalBySku)}
                    />
                </MobileItem.LeftSide>
                <MobileItem.RightSide>
                    <VariationCount
                        count={inTrolleyTotalBySku}
                        maxCount={totalBySku}
                    />
                </MobileItem.RightSide>
            </MobileItem>
        )
    })
}

export default PickingOrInTrolleyItemList;
